<div class="card card-wider card-cascade">
    <div class="view gradient-card-header primary-gradient white-text">
        <h3 class='h3-responsive text-center'>{{Assessment?.name}}</h3>
    </div>
    <div class="card-body">
      <div *ngFor="let criteria of Criteria;index as index;"
        [id]="getScaleResultNavigatorId(criteria.scaleResult)" class="row d-report-print-page">
        <div class="card card-wider card-cascade mb-md-4 md-0 col">
          <div class="view gradient-card-header secondary-gradient white-text">
              <h3 class='h3-responsive text-center'>{{criteria.scaleResult.scale?.name}} (Scored {{criteria.scaleResult.score}} out of {{criteria.scaleResult.scale.getMaxScore()}})</h3>
          </div>
          <div class="card-body">
            <div class="row justify-content-center">
              <pcl-criteria-icon class="col-3 col-lg-2" [criteria]="criteria.name" [checked]="criteria.hasPTSD"></pcl-criteria-icon> 
            </div>
            <!-- <div class="row mb-3">
              <app-scale-range-content class="col" [scaleResult]="criteria.scaleResult"></app-scale-range-content>
            </div> -->
            <div class="row">
              <app-scale-questions-list  class="col" [Questions]="AssessmentResult.assessment.getQuestionsForScale(criteria.scaleResult.scale)"></app-scale-questions-list>
            </div>
          </div>
      </div>
</div>



// WEBPACK FOOTER //
// ./src/app/reports/report-items/pcl-assessment-results/pcl-assessment-results.component.html